import React, { useEffect } from "react";
import "./WishList.css";
import Top_Filter_Div from "../product_listing/top_filter_div/Top_Filter_Div";
import Product_Info_Grid_View from "../common_components/product_info_grid_view/Product_Info_Grid_View";
import Product_Info_List_View from "../common_components/product_info_list_view/Product_Info_List_View";
import { Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";

const WishList = () => {
  const dispatch = useDispatch();
  const allWishlist = useSelector((state) => state.wishlist.allWishlist);
  const user = useSelector((state) => state.myaccount.addMyaccount);
  useEffect(() => {
    if (user?.id) {
      dispatch(getAllWishlist());
    }
  }, []);

  const products = [
    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
      company: "Nescafe",
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: true,
      company: "Kellog's",
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },
  ];

  return (
    <section className="Product_Listing_Page WishList">
      <Tab.Container id="left-tabs-example" defaultActiveKey="Grid">
        <Top_Filter_Div pageTitle="Wishlist" />

        <div className="container">
          <Tab.Content>
            <Tab.Pane eventKey="Grid">
              <div className="row">
                {allWishlist?.data?.length > 0 ? (
                  allWishlist.data.map((product) => (
                    <div
                      className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-5 custom_col"
                      key={product?.id}
                    >
                      <Product_Info_Grid_View
                        product={product?.Product}
                        showQty
                      />
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center py-5">
                    <h5>No products in your wishlist yet.</h5>
                  </div>
                )}
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="List">
              {allWishlist?.data?.length > 0 ? (
                allWishlist.data.map((product, index) => (
                  <Product_Info_List_View
                    key={product?.Product?.id || index}
                    products={product?.Product}
                    showQty
                  />
                ))
              ) : (
                <div className="col-12 text-center py-5">
                  <h5>No products in your wishlist yet.</h5>
                </div>
              )}
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </section>
  );
};

export default WishList;
